import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { AgFinancingCreditAnalysisStatus, AgFinancingInput } from '@indigo-ag/schema';

import { CreditUtil } from 'shared';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { upsertFinancingAgFinancing } from 'features/brazil-grower/queries';
import { ToggleOnHold } from '../../ToggleOnHold/ToggleOnHold';

export const ToggleOnHoldCreditAnalysis: React.FunctionComponent = () => {
  /**
   * Finance Process Context
   */
  const { agFinance } = useContext(FinanceProcessContext);

  /**
   * State
   */
  const [isAnalysisOnHold, setIsAnalysisOnHold] = useState(
    agFinance?.phase2?.credit?.status === AgFinancingCreditAnalysisStatus.ON_HOLD
  );

  /**
   * Mutations
   */
  const [upsertFinancingAgFinancingFn] = useMutation(upsertFinancingAgFinancing);

  const toggleOnHoldCreditAnalysis = (decisionNotes: string) => {
    const newAgFinancingData: Partial<AgFinancingInput> = {
      id: agFinance?.id,
      phase2: {
        credit: {
          status: CreditUtil.isOnHold(agFinance?.phase2?.credit?.status)
            ? AgFinancingCreditAnalysisStatus.STARTED
            : AgFinancingCreditAnalysisStatus.ON_HOLD,
          decisionNotes: decisionNotes
        }
      }
    };

    return upsertFinancingAgFinancingFn({
      variables: {
        data: newAgFinancingData
      }
    }).then(() => setIsAnalysisOnHold(!isAnalysisOnHold));
  };

  return (
    <ToggleOnHold
      visible={CreditUtil.canOnHoldResume(agFinance?.phase2)}
      isOnHold={isAnalysisOnHold}
      onConfirmation={toggleOnHoldCreditAnalysis}
    />
  );
};
